import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AdminPanelComponent } from "./core/layout/admin-panel/admin-panel.component";
import { AuthGuard } from "./core/guards/auth/auth.guard";
import { RoleAuthGuard } from "./core/guards/role_guard/role-auth.guard";

// const routes: Routes = [
//   {
//     path: "login",
//     loadChildren: "@modules/auth/login/login.module#LoginModule",
//   },
//   {
//     path: "",
//     component: AdminPanelComponent,
//     canActivate: [AuthGuard],
//     // Apply to ALL child routes
//     children: [
//       {
//         path: "",
//         redirectTo: "dashboard",
//         pathMatch: "full",
//       },
//       {
//         path: "",
//         redirectTo: "adminDashboard",
//         pathMatch: "full",
//       },
//       {
//         path: "dashboard2",
//         loadChildren: "@modules/dashboard2/dashboard2.module#Dashboard2Module",
//         data: {
//           breadcrumb: "Admin Dashboard",
//           permission: 'CLIENT_MANAGE',
//           role: ['admin', 'super_admin'],
//           type_id: [1]
//         },
//       },
//       {
//         path: "dashboard/:id",
//         loadChildren: "@modules/dashboard/dashboard.module#DashboardModule",
//         data: {
//           breadcrumb: "User Dashboard",
//           permission: 'CLIENT_MANAGE',
//           role: ['General Staff', 'staff'],
//           type_id: [2]
//         },
//       },
//       // {
//       //   path: "company",
//       //   loadChildren: "@modules/company/company.module#CompanyModule",
//       //   // canActivateChild: [RoleAuthGuard],
//       //   data: {
//       //     breadcrumb: "Company",
//       //     permission: 'COMPANY_VIEW', // Requires this permission
//       //     // role: ['admin', 'staff']
//       //   },
//       // },
//       {
//         path: "organization",
//         loadChildren: "@modules/organization/organization.module#OrganizationModule",
//         // canActivateChild: [RoleAuthGuard],
//         data: {
//           breadcrumb: "Organization",
//           permission: 'organization_VIEW', // Requires this permission
//           // role: ['admin', 'staff']
//         },
//       },
//       {
//         path: "search",
//         loadChildren: "@modules/searchList/searchModule.module#SearchModuleModule",
//         data: {
//           breadcrumb: "Search",
//         },
//       },
//       // {
//       //   path: "leads",
//       //   loadChildren: "@modules/leads/leads.module#LeadsModule",
//       //   data: {
//       //     breadcrumb: "Leads",
//       //   },
//       // },
//       // {
//       //   path: "lead-contacts",
//       //   loadChildren:
//       //     "@modules/lead-contacts/lead-contacts.module#LeadContactsModule",
//       //   data: {
//       //     breadcrumb: "Lead Contacts",
//       //   },
//       // },
//       // {
//       //   path: "bid-information",
//       //   loadChildren:
//       //     "@modules/bid-information/bid-information.module#BidInformationModule",
//       //   data: {
//       //     breadcrumb: "Bid Information",
//       //   },
//       // },
//       // {
//       //   path: "groups",
//       //   loadChildren: "@modules/groups/groups.module#GroupsModule",
//       //   data: {
//       //     breadcrumb: "Groups",
//       //   },
//       // },
//       // {
//       //   path: "merge-fields",
//       //   loadChildren:
//       //     "@modules/merge-fields/merge-fields.module#MergeFieldsModule",
//       //   data: {
//       //     breadcrumb: "Merge Fields",
//       //   },
//       // },
//       // {
//       //   path: "email-template",
//       //   loadChildren:
//       //     "@modules/email-template/email-template.module#EmailTemplateModule",
//       //   data: {
//       //     breadcrumb: "Email Template",
//       //   },
//       // },
//       // {
//       //   path: "create-email",
//       //   loadChildren:
//       //     "@modules/create-email/create-email.module#CreateEmailModule",
//       //   data: {
//       //     breadcrumb: "Create Email",
//       //   },
//       // },
//       // {
//       //   path: "send-queue-email",
//       //   loadChildren:
//       //     "@modules/send-queue-email/send-queue-email.module#SendQueueEmailModule",
//       //   data: {
//       //     breadcrumb: "Send Queue Email",
//       //   },
//       // },
//       // {
//       //   path: "marketing",
//       //   loadChildren: "@modules/marketing/marketing.module#MarketingModule",
//       //   data: {
//       //     breadcrumb: "Marketing",
//       //   },
//       // },
//       // {
//       //   path: "stages",
//       //   loadChildren: "@modules/stages/stages.module#StagesModule",
//       //   data: {
//       //     breadcrumb: "Stages",
//       //   },
//       // },
//       // {
//       //   path: "product-category",
//       //   loadChildren:
//       //     "@modules/product-category/product-category.module#ProductCategoryModule",
//       //   data: {
//       //     breadcrumb: "Product Category",
//       //   },
//       // },
//       // {
//       //   path: "products",
//       //   loadChildren: "@modules/products/products.module#ProductsModule",
//       //   data: {
//       //     breadcrumb: "Products",
//       //   },
//       // },
//       // {
//       //   path: "products-stages",
//       //   loadChildren:
//       //     "@modules/products-stages/products-stages.module#ProductsStagesModule",
//       //   data: {
//       //     breadcrumb: "Products Stages",
//       //   },
//       // },
//   {
//     path: "change-password",
//     loadChildren:
//       "@modules/change-password/change-password.module#ChangePasswordModule",
//     data: {
//       breadcrumb: "Change Password",
//     },
//       },
//       // {
//       //   path: "setting",
//       //   loadChildren:
//       //     "@modules/setting/setting.module#SettingModule",
//       //   data: {
//       //     breadcrumb: "Setting",
//       //   },
//       // },
//       // {
//       //   path: "user",
//       //   loadChildren:
//       //     "@modules/user/user.module#UserModule",
//       //   data: {
//       //     breadcrumb: "Roles",
//       //     permission: 'CLIENT_MANAGE',
//       //     role: ['admin', 'super_admin'],
//       //     type_id: [2]
//       //   },
//       // },
//       // {
//       //   path: "notes",
//       //   loadChildren: "@modules/sharedComponent/notes/notes.module#NotesModule",
//       //   data: {
//       //     breadcrumb: "notes",
//       //   },
//       // },
//       // {
//       //   path: "files",
//       //   loadChildren: "@modules/sharedComponent/files/files.module#FilesModule",
//       //   data: {
//       //     breadcrumb: "files",
//       //   },
//       // },

//       {
//         path: "profile",
//         loadChildren:
//           "@modules/profile/userProfile.module#UserProfileModule",
//         data: {
//           breadcrumb: "User Profile",
//         },
//       },
//       // {
//       //   path: "tags",
//       //   canActivateChild: [RoleAuthGuard],
//       //   loadChildren: "@modules/tags/tags.module#TagsModule",
//       //   data: {
//       //     breadcrumb: "Tags",
//       //     permission: 'CLIENT_MANAGE',
//       //     role: ['General Staff', 'staff'],
//       //     type_id: [1]
//       //   },
//       // },
//       // {
//       //   path: "tickets",
//       //   loadChildren: "@modules/tickets/tickets.module#TicketsModule",
//       //   data: {
//       //     breadcrumb: "Tickets",
//       //   },
//       // },
//       // {
//       //   path: "roles",
//       //   loadChildren: "@modules/accessRoles/roles/roles.module#RolesModule",
//       //   data: {
//       //     breadcrumb: "Roles",
//       //     permission: 'CLIENT_MANAGE',
//       //     role: ['admin', 'super_admin'],
//       //     type_id: [2]
//       //   },
//       // },
//       // {
//       //   path: "department",
//       //   loadChildren: "@modules/department/department.module#DepartmentModule",
//       //   data: {
//       //     breadcrumb: "Department",
//       //   },
//       // }
//     ],
//   },

// ];

//new routes

const routes: Routes = [
  {
    path: "login",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("@modules/auth/login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "forgot-password",
    loadChildren:
      "@modules/forgot-password/forgot-password.module#ForgotPasswordModule",
    data: {
      breadcrumb: "Forgot Password",
    },
  },
  {
    path: "reset",
    loadChildren:
      "@modules/reset-password-via-token/reset-password-via-token.module#ResetPasswordViaTokenModule",
    data: {
      breadcrumb: "Reset Password Via Token",
    },
  },
  {
    path: "",
    component: AdminPanelComponent,
    canActivate: [AuthGuard],
    // Apply to ALL child routes
    children: [
      //start admin routes
      // {
      //   path: "admin",
      //   // loadChildren: () => import('./modules/sharedRoutes/admin.module').then(m => m.AdminModule),
      //   loadChildren: "@modules/sharedRoutes/admin.module#AdminModule",
      //   data: {
      //     breadcrumb: "Admin Dashboard",
      //     permission: "CLIENT_MANAGE",
      //     role: ["admin", "super_admin"],
      //     type_id: [1],
      //   },
      // },
      { path: "", redirectTo: "dashboard", pathMatch: "full" },

      {
        path: "dashboard2",
        loadChildren: "@modules/dashboard2/dashboard2.module#Dashboard2Module",
        data: {
          breadcrumb: "Admin Dashboard",
          permission: 'CLIENT_MANAGE',
          role: ['admin', 'super_admin'],
          type_id: [1]
        },
      },
      {
        path: "organization",
        loadChildren: "@modules/organization/organization.module#OrganizationModule",
        // canActivateChild: [RoleAuthGuard],
        data: {
          breadcrumb: "Organization",
          permission: 'organization_VIEW', // Requires this permission
          // role: ['admin', '"STAFF"']
        },
      },
      //clients routes
      {
        path: "organizationUser",
        loadChildren:
          "@modules/organizationUser/organizationUser.module#OrganizationUserModule",
        canActivateChild: [RoleAuthGuard],
        data: {
          breadcrumb: "Organization User",
          //   permission: "organization_VIEW", // Requires this permission
          role: ["Admin", "Super Admin", "SUPER_ADMIN", "ADMIN"],
          type_id: [2]
        },
      },
      {
        path: "organizationUser/:id",
        loadChildren: "@modules/organizationUser/organizationUser.module#OrganizationUserModule",
        // canActivateChild: [RoleAuthGuard],
        data: {
          breadcrumb: "Organization User",
          //  permission: 'organization_VIEW', // Requires this permission
          // role: ['admin', 'staff']
        },
      },

      //end admin routes



      //end-user routes start 
      {
        path: "user",
        //loadChildren: () => import('./modules/sharedRoutes/client-user.module').then(m => m.ClientUserModule)
        loadChildren:
          "@modules//sharedRoutes/end-user.module#EndUserModule",

        data: {
          breadcrumb: "Customer Dashboard",
          permission: "CLIENT_MANAGE",
          role: ["admin", "super_admin"],
          type_id: [2],
        },
      },
      //end-user routes end

      //start customer routes
      {
        path: "client",
        //loadChildren: () => import('./modules/sharedRoutes/client-user.module').then(m => m.ClientUserModule)
        loadChildren:
          "@modules/sharedRoutes/client-user.module#ClientUserModule",

        data: {
          //breadcrumb: "Customer Dashboard",
          permission: "CLIENT_MANAGE",
          role: ["admin", "super_admin"],
          type_id: [2],
        },
      },
      {
        path: "company",
        loadChildren: "@modules/company/company.module#CompanyModule",
        // canActivateChild: [RoleAuthGuard],
        data: {
          breadcrumb: "Company",
          permission: "COMPANY_VIEW", // Requires this permission
          // role: ['admin', 'staff']
        },
      },
      {
        path: "clientCompany",
        loadChildren:
          "@modules/clientCompany/clientCompany.module#ClientCompanyModule",
        // canActivateChild: [RoleAuthGuard],
        data: {
          breadcrumb: "Customer ",
          permission: "COMPANY_VIEW", // Requires this permission
          // role: ['admin', 'staff']
        },
      },
      {
        path: "lead",
        loadChildren:
          "@modules/lead/clientCompany.module#ClientCompanyModule",
        // canActivateChild: [RoleAuthGuard],
        data: {
          breadcrumb: "Lead ",
          permission: "COMPANY_VIEW", // Requires this permission
          // role: ['admin', 'staff']
        },
      },
      {
        path: "admin-user",
        loadChildren:
          "@modules/admin-user/adminUser.module#AdminUserModule",
        // canActivateChild: [RoleAuthGuard],
        data: {
          breadcrumb: "Admin",
          permission: "COMPANY_VIEW", // Requires this permission
          // role: ['admin', 'staff']
        },
      },
      {
        path: "dashboard",
        loadChildren: "@modules/dashboard/dashboard.module#DashboardModule",
      },
      {
        path: "dashboard/:id",
        loadChildren: "@modules/dashboard/dashboard.module#DashboardModule",
        data: {
          breadcrumb: "Customer Dashboard",
          permission: "CLIENT_MANAGE",
          role: ["General Staff", "staff"],
          type_id: [2],
        },
      },

      {
        path: "department",
        loadChildren: "@modules/department/department.module#DepartmentModule",
        data: {
          breadcrumb: "Department",
        },
      },
      {
        path: "audit-log",
        loadChildren: "@modules/audit-log/audit-log.module#AuditLogModule",
        data: {
          breadcrumb: "Audit Log",
        },
      },

      {
        path: "change-password",
        loadChildren:
          "@modules/change-password/change-password.module#ChangePasswordModule",
        data: {
          breadcrumb: "Change Password",
        },
      },
      {
        path: "forgot-password",
        loadChildren:
          "@modules/forgot-password/forgot-password.module#ForgotPasswordModule",
        data: {
          breadcrumb: "Forgot Password",
        },
      },
      {
        path: "create-email",
        loadChildren:
          "@modules/create-email/create-email.module#CreateEmailModule",
        data: {
          breadcrumb: "Create Email",
        },
      },
      {
        path: "setting",
        loadChildren:
          "@modules/setting/setting.module#SettingModule",
        data: {
          breadcrumb: "Setting",
        },
      },
      {
        path: "tickets",
        loadChildren: "@modules/tickets/tickets.module#TicketsModule",
        data: {
          breadcrumb: "Tickets",
        },
      },
      {
        path: "profile",
        loadChildren: "@modules/profile/userProfile.module#UserProfileModule",
        data: {
          breadcrumb: "User Profile",
        },
      },
      {
        path: "tags",
        canActivateChild: [RoleAuthGuard],
        loadChildren: "@modules/tags/tags.module#TagsModule",
        data: {
          breadcrumb: "Tags",
          permission: 'CLIENT_MANAGE',
          // role: ['General Staff', 'staff'],
          // type_id: [1]
        },
      },

      {
        path: "reset-password",
        loadChildren: "@modules/sharedComponent/reset-password/reset-password.module#ResetPasswordModule",
        data: {
          breadcrumb: "files",
        },
      },
      {
        path: "email-template",
        loadChildren:
          "@modules/email-template/email-template.module#EmailTemplateModule",
        data: {
          breadcrumb: "Email Template",
        },
      },


      //end customer routes
    ],
  },

  // { path: "", redirectTo: "login", pathMatch: "full" },
  { path: "**", redirectTo: "login" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // to emit router events when we try to navigate to the same URL
      onSameUrlNavigation: "reload",
    }),
  ],

  exports: [RouterModule],
})
export class AppRoutingModule { }
